const sentryConfigs = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
};

export default sentryConfigs;
